(function(){
    let el_trigger_point = document.querySelector(".product-page__key-features");
    let trigger_point_y = 0;
    let el_sticky_outter_container = document.querySelector(".product__sticky-outter-container");
    let breakpoint = 768;
    let sticky_height = '3.75rem';

    function offset(el) {
        if(el) {
            var rect = el.getBoundingClientRect();
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }
	}

    function page_scrolled(e) {
        let position = document.documentElement.scrollTop || document.body.scrollTop;
        if (position > trigger_point_y) {
            el_sticky_outter_container.style['height'] = sticky_height;
        }
        else {
            el_sticky_outter_container.style['height'] = '0rem';
        }
    }

    function init() {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (vw < breakpoint) {
            el_sticky_outter_container.style['display'] = 'none';
        }
        else {
            el_sticky_outter_container.style['display'] = 'block';
            window.addEventListener('scroll', page_scrolled);
        }
        if(el_trigger_point)
            trigger_point_y = offset(el_trigger_point).top;
    }

    init();
})();
